import { i18n } from '@/i18n';
import { alertController } from '@ionic/vue';

export const alertCopyFragenblock = async (onConfirmCallback: () => void) => {
    // @ts-ignore Type instantiation is excessively deep and possibly infinite
    const t = i18n.global.t;
    const alert = await alertController.create({
        header: t('hzba.alerts.copyFragenblock.title'),
        message: t('hzba.alerts.copyFragenblock.message'),
        buttons: [{
            text: t("hzba.buttons.nein"),
            role: 'cancel',
            handler: () => {
                return;
            },
        },
        {
            text: t("hzba.buttons.ja"),
            role: 'confirm',
            handler: () => {
                onConfirmCallback();
            },
        }]
    });

    alert.present();
};